import { createSlice } from "@reduxjs/toolkit";
import { fetchDriverLocation } from "../thunks/getDriverLocation";

const getDriverLocationReducer = createSlice({
  name: "driverLocation",
  initialState: {
    locations: [],

    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDriverLocation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDriverLocation.fulfilled, (state, action) => {
        state.locations = action.payload.data;

        state.status = "success";
        state.error = null;
      })
      .addCase(fetchDriverLocation.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export default getDriverLocationReducer.reducer;
